import Monogram from './Monogram'

export default function StandingsTable({ name, rows, highlight = [] }) {
  const hi = new Set(highlight)
  return (
    <div className="tbl">
      <div className="gh"><b>Grupo {name}</b><em>Campo 1 &amp; 2</em></div>
      <table>
        <thead>
          <tr>
            <th>#</th><th className="l">Equipa</th><th>J</th><th>V</th>
            <th>E</th><th>D</th><th>DG</th><th className="pts-h">P</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={r.team.slug}
              className={[r.position <= 2 ? 'q' : '', hi.has(r.team.slug) ? 'match-team' : '']
                .filter(Boolean)
                .join(' ')}
            >
              <td className="pos"><span className="n">{r.position}</span></td>
              <td className="team">
                <div className="row"><Monogram team={r.team} /><b>{r.team.shortName}</b></div>
              </td>
              <td>{r.played}</td><td>{r.won}</td><td>{r.drawn}</td><td>{r.lost}</td>
              <td>{r.gdLabel}</td><td className="pts">{r.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
